import { defineMessages, IntlShape } from "react-intl";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";

import { SortField } from "./getSortFieldDisplayName";

const messagesAsc = defineMessages<SortField>({
  [SortField.CREATED_AT]: {
    id: "component.resources.orderSelect.sort.createdAt.asc",
    defaultMessage: "Oldest first",
    description: "Resources list customization sort - Oldest first",
  },
  [SortField.FILE_SIZE]: {
    id: "component.resources.orderSelect.sort.fileSize.asc",
    defaultMessage: "Smallest first",
    description: "Deals card filter option - Smallest first",
  },
  [SortField.NAME]: {
    id: "component.resources.orderSelect.sort.name.asc",
    defaultMessage: "A > Z",
    description: "Resources list customization sort - A > Z",
  },
  [SortField.OWNER]: {
    id: "component.resources.orderSelect.sort.owner.asc",
    defaultMessage: "A > Z",
    description: "Deals card filter option - A > Z",
  },
  [SortField.TYPE]: {
    id: "component.resources.orderSelect.sort.fileType.asc",
    defaultMessage: "A > Z",
    description: "Resources list fileType sort - A > Z",
  },
  [SortField.UPDATED_AT]: {
    id: "component.resources.orderSelect.sort.updatedAt.asc",
    defaultMessage: "Oldest first",
    description: "Resources list customization sort - Oldest first",
  },
});

const messagesDesc = defineMessages<SortField>({
  [SortField.CREATED_AT]: {
    id: "component.resources.orderSelect.sort.createdAt.desc",
    defaultMessage: "Newest first",
    description: "Resources list customization sort - Newest first",
  },
  [SortField.FILE_SIZE]: {
    id: "component.resources.orderSelect.sort.fileSize.desc",
    defaultMessage: "Largest first",
    description: "Deals card filter option - Largest first",
  },
  [SortField.NAME]: {
    id: "component.resources.orderSelect.sort.name.desc",
    defaultMessage: "Z > A",
    description: "Resources list customization sort - Name desc direction",
  },
  [SortField.OWNER]: {
    id: "component.resources.orderSelect.sort.owner.desc",
    defaultMessage: "Z > A",
    description: "Resources list customization sort - Z > A",
  },
  [SortField.TYPE]: {
    id: "component.resources.orderSelect.sort.fileType.desc",
    defaultMessage: "Z > A",
    description: "Resources list fileType sort - Z > A",
  },
  [SortField.UPDATED_AT]: {
    id: "component.resources.orderSelect.sort.updatedAt.desc",
    defaultMessage: "Newest first",
    description: "Resources list customization sort - Newest first",
  },
});

const getSortDirectionNameForField = (
  intl: IntlShape,
  fieldName: SortField,
  order: SortOrder
): string =>
  order === SortOrder.DESC
    ? intl.formatMessage(messagesDesc[fieldName])
    : intl.formatMessage(messagesAsc[fieldName]);

export default getSortDirectionNameForField;
